import { useEffect } from "react";
import { Link } from "react-router-dom";
import { NavHeader } from "../components/NavHeader";
import { Footer } from "../components/Footer";

const ARTICLES = [
  {
    slug: "rising-sign-vs-sun-sign-vs-moon-sign",
    title: "Rising sign, sun sign, moon sign",
    subtitle: "The three placements every reading is really about",
    intro: "Most people know their sun sign. Fewer know that a real astrological reading balances three placements, not one. Here is what each of them actually does.",
    read_time: "8 min read",
  },
  {
    slug: "how-to-read-a-birth-chart",
    title: "How to read a birth chart",
    subtitle: "The anatomy, in plain language",
    intro: "A birth chart looks intimidating on the page and is actually made of a small number of parts. Here is what each of them means, in plain language.",
    read_time: "9 min read",
  },
  {
    slug: "vedic-vs-western-astrology",
    title: "Vedic and Western astrology, side by side",
    subtitle: "Two traditions, one sky",
    intro: "Vedic and Western astrology use the same sky and mostly disagree. Here is what each tradition is really measuring, and why your sun sign moves between them.",
    read_time: "10 min read",
  },
];

export const LearnHubPage = () => {
  useEffect(() => {
    document.title = "Learn Astrology · Guides & Essays · Astrarium";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "Long-form guides on astrology, written straight. Rising vs sun vs moon signs, how to read a birth chart, Vedic vs Western astrology explained clearly.");
  }, []);

  return (
    <>
      <NavHeader />
      <main
        data-testid="learn-hub-page"
        className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 pt-28 sm:pt-32 pb-12"
      >
        <p className="text-stardust/70 uppercase tracking-[0.5em] text-[10px] mb-5 text-center">The learn library</p>
        <h1 className="font-display text-4xl sm:text-6xl text-[#F5EBD8] text-center leading-tight mb-5">
          Astrology, told straight<span className="text-stardust">.</span>
        </h1>
        <p className="font-serif-italic text-slate-300/90 text-lg sm:text-2xl leading-relaxed text-center mb-14 max-w-2xl mx-auto">
          Long-form guides for the curious. No zodiac horoscope filler, no
          twelve-adjective descriptions of your sign. Just the ideas underneath.
        </p>

        <section className="space-y-4">
          {ARTICLES.map((a) => (
            <Link
              key={a.slug}
              to={`/learn/${a.slug}`}
              data-testid={`learn-hub-card-${a.slug}`}
              className="group block p-6 sm:p-7 rounded-xl bg-white/[0.02] border border-white/10 hover:border-stardust/50 hover:bg-white/[0.04] transition-all"
            >
              <p className="text-stardust/70 uppercase tracking-[0.3em] text-[10px] mb-3">{a.read_time}</p>
              <h2 className="font-display text-2xl sm:text-3xl text-[#F5EBD8] group-hover:text-stardust transition-colors leading-tight mb-2">
                {a.title}
              </h2>
              <p className="text-stardust/80 italic text-base mb-3">{a.subtitle}</p>
              <p className="text-slate-300 text-sm leading-relaxed">{a.intro}</p>
              <p className="text-stardust/80 uppercase tracking-[0.25em] text-[10px] mt-4 group-hover:text-stardust transition-colors">
                Read essay ✦
              </p>
            </Link>
          ))}
        </section>

        <section className="mt-16 text-center py-10 border-t border-white/[0.06]">
          <h2 className="font-display text-3xl sm:text-4xl text-[#F5EBD8] mb-3 leading-tight">
            Ready for your own almanac?
          </h2>
          <p className="text-slate-300 leading-relaxed max-w-2xl mx-auto mb-6">
            The guides here are for context. Astrarium itself draws a full personal reading from your birth date, place, and time.
          </p>
          <Link
            to="/"
            data-testid="learn-hub-cta"
            className="inline-flex items-center bg-stardust hover:bg-stardust-light text-cosmic-900 rounded-md uppercase tracking-[0.3em] text-xs px-10 py-5 font-medium shadow-[0_0_28px_rgba(226,194,117,0.25)] hover:shadow-[0_0_44px_rgba(226,194,117,0.45)] transition-all"
          >
            Get my reading ✦
          </Link>
        </section>
      </main>
      <Footer />
    </>
  );
};
